// Cab/Vehicle Category Constants for FusionCab - Backend Compatible

// Mirrors fusion_backend's FLEET_CATEGORIES (src/constants/fleetConstants.js)
// - Plan.vehicle_category is a Postgres enum array restricted to exactly
// these values, so this list must stay in sync with the backend's.
export const CAB_TYPES = {
  COMPACT: "Compact",
  HATCHBACK: "Hatchback",
  SEDAN: "Sedan",
  COMPACT_SUV: "Compact SUV",
  CROSSOVER_SUV: "Crossover SUV",
  MUV: "MUV/MPV",
  SUV: "SUV",
  TEMPO_TRAVELER: "Tempo Traveler",
  TRAVELER: "Traveler",
  MINI_BUS: "Mini Bus",
  BUS: "Bus",
} as const;

export type CabType = (typeof CAB_TYPES)[keyof typeof CAB_TYPES];

export const CAB_TYPE_OPTIONS: { value: CabType; label: string }[] =
  Object.values(CAB_TYPES).map((value) => ({ value, label: value }));
